import React, { useState, useRef } from 'react';

import { Button } from '@mui/material';
import LoaderNew from '../../../common/LoaderNew';
//import Recaptcha from '../../../common/Recaptcha';

const SignupPassword = ({ classes, hashData, submitPassword, openRecoverPassword, loading }) => {
  const [password, setPassword] = useState('');
  //const [capchaValChecked, setCapchaValChecked] = useState(false);

  return (
    <div className={classes.paper}>
      <div style={{ paddingBottom: '7px' }}>
        <span>
          {hashData.is_new_account ? 'New account' : 'Account exist'}
        </span>
      </div>
      <div className={classes.mb20}>
        <span style={{ fontWeight: 'bold' }}>
          {hashData.email}
        </span>
      </div>

      <div>
        <div className={classes.mb5}>
          <span className={classes.helpText}>
            {hashData.is_new_account ? 'Create a password' : 'Your password'}
          </span>
        </div>
        <input
          label='Password'
          autoFocus 
          className={`${classes.insetShadowInput}`}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') submitPassword(password, hashData.email);
          }}
        />
      </div>

      {/* <div className={classes.mt10}>
        <Recaptcha
          onCheck={() => setCapchaValChecked(true)}
          onExpired={() => setCapchaValChecked(false)}
        />
      </div> */}
      
      <div>
        <Button
          disabled={(password === '') || loading} //!capchaValChecked || 
          disableElevation
          size="small"
          variant="contained"
          className={`${classes.okBtn} ${classes.mt20}`}
          onClick={(e) => {
            e.preventDefault();
            submitPassword(password, hashData.email);
          }}>
          {loading ? <LoaderNew color='white'/> : 'Submit'}
        </Button>
      </div>
      {!hashData.is_new_account &&
        <div className={`${classes.alignJustifyCenter} ${classes.mt20}`}>
          <div style={{padding: '0px 0px 10px 2px'}}>
            <span className={`${classes.helpText} ${classes.mr5}`}>
              Forgot password?
            </span>
            <a
              onClick={() => openRecoverPassword()}
              className={`${classes.helpAction}`}>
              Reset
            </a>
          </div>
        </div>
      }
    </div>
  )
};

export default SignupPassword;